import { render, staticRenderFns } from "./LabelModal.vue?vue&type=template&id=f92c8f6a"
import script from "./LabelModal.vue?vue&type=script&lang=ts"
export * from "./LabelModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports